<template>
  <el-button-group
     class="el-button-group--nuttrema-radiocheck-group"
    :class="[ theme ? `theme-${theme}` : '' ]">
    <slot></slot>
  </el-button-group>
</template>

<script>
import { pull, includes, clone } from 'lodash';
import Emitter from 'components/mixins/emitter';

const MODES = Object.freeze({
  RADIO: 'radio',
  CHECKBOX: 'checkbox',
});

const ACTIONS = Object.freeze({
  SET: 'set',
  UNSET: 'unset',
});

export default {
  name: 'nuttrema-radiocheck-group',
  componentName: 'NuttremaRadiocheckGroup',
  mixins: [Emitter],
  props: {
    value: {},
    disabled: Boolean,
    mode: {
      type: String,
      required: false,
      default: MODES.RADIO,
    },
    required: Boolean,
    theme: String,
    size: {
      type: String,
      required: false,
      default: 'small',
    },
  },
  data() {
    return {
      MODES,
      ACTIONS,
    };
  },
  methods: {
    handleChange(params) {
      if (this.mode === MODES.RADIO) {
        if (params.action === ACTIONS.SET) this.$emit('input', params.value);
        if (params.action === ACTIONS.UNSET) this.$emit('input', null);
      }

      if (this.mode === MODES.CHECKBOX) {
        const value = clone(this.value);

        if (params.action === ACTIONS.SET && !includes(value, params.value)) value.push(params.value);
        if (params.action === ACTIONS.UNSET) pull(value, params.value);

        this.$emit('input', value);
      }

      this.$emit('change');
    },
  },
  created() {
    this.$on('handleChange', this.handleChange);
  },
};
</script>

<style lang="scss" scoped>

  $theme-default-active-color: #009692;
  $theme-default-inactive-color: #fff;
  $theme-default-disabled-color: #fff;

  $theme-default-active-border-color: #fff;
  $theme-default-inactive-border-color: #fff;
  $theme-default-disabled-border-color: transparent;

  $theme-default-active-background-color: #fff;
  $theme-default-inactive-background-color: transparent;
  $theme-default-disabled-background-color: transparent;

  $theme-gray-active-color: #fff;
  $theme-gray-inactive-color: #607d8b;
  $theme-gray-disabled-color: rgba(#607d8b, 0.5);

  $theme-gray-active-border-color: #607d8b;
  $theme-gray-inactive-border-color: #607d8b;
  $theme-gray-disabled-border-color: #fff;

  $theme-gray-active-background-color: #607d8b;
  $theme-gray-inactive-background-color: transparent;
  $theme-gray-disabled-background-color: transparent;

  @mixin mainStyle($active-color, $inactive-color, $disabled-color, $active-border-color, $inactive-border-color, $disabled-border-color, $active-background-color, $inactive-background-color, $disabled-background-color) {
    /deep/ .el-button {

      color: $inactive-color;
      border-radius: 8px;
      background-color: $inactive-background-color;
      border: 1px solid $inactive-border-color;

      &:first-child {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }

      &:last-child {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }

      &:not(:first-child):not(:last-child) {
        border-radius: 0;
      }

      &:only-child {
        border-radius: 8px;
      }


      &.is-active {
        color: $active-color;
        background-color: $active-background-color;
      }

      &.is-future {
        color: $active-color;
        background-color: rgba($active-background-color, 0.5);
      }

      &.is-disabled {
        color: $disabled-color;
        border-color: $disabled-border-color;
        background-color: $disabled-background-color;
        &.is-active {
          border-radius: 8px;
          margin-right: 0.25em;
          color: $active-color;
          background-color: $active-background-color;
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .el-button-group--nuttrema-radiocheck-group {
    @include mainStyle(
      $theme-default-active-color,
      $theme-default-inactive-color,
      $theme-default-disabled-color,
      $theme-default-active-border-color,
      $theme-default-inactive-border-color,
      $theme-default-disabled-border-color,
      $theme-default-active-background-color,
      $theme-default-inactive-background-color,
      $theme-default-disabled-background-color
    );

    &.theme-gray {
      @include mainStyle(
        $theme-gray-active-color,
        $theme-gray-inactive-color,
        $theme-gray-disabled-color,
        $theme-gray-active-border-color,
        $theme-gray-inactive-border-color,
        $theme-gray-disabled-border-color,
        $theme-gray-active-background-color,
        $theme-gray-inactive-background-color,
        $theme-gray-disabled-background-color
      );
    }

    &.theme-global {
      .nuttrema-theme-professional-topography & {
        @include mainStyle(
          $theme-gray-active-color,
          $theme-gray-inactive-color,
          $theme-gray-disabled-color,
          $theme-gray-active-border-color,
          $theme-gray-inactive-border-color,
          $theme-gray-disabled-border-color,
          $theme-gray-active-background-color,
          $theme-gray-inactive-background-color,
          $theme-gray-disabled-background-color
        );
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ui/button/nuttrema-radiocheck-group.vue